import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { lockBodyScroll } from './lock_body_scroll';
/**
 * Covers the page behind a compact options sheet.
 *
 * Closing is left to Headless UI's outside-click handling (pointerup, or touchend on a phone). Listbox's
 * render prop does not include `close` in @headlessui/react 2.2.4. Cancelling pointerdown keeps the click
 * from landing on the page once this layer unmounts; it does not mark the later pointerup as default-prevented,
 * which is what that outside-click listener checks.
 *
 * `isPressGuarded` lets the opening press release through to the trigger, see `useOptionsSheetPressGuard`.
 */
export const OptionsSheetBackdrop = ({ isPressGuarded = false }) => {
    useEffect(() => lockBodyScroll(), []);
    return (_jsx("div", { "data-testid": 'nucleus-options-sheet-backdrop', "aria-hidden": 'true', className: `nucleus-fixed nucleus-inset-0 nucleus-z-[60] nucleus-bg-neutral-900/40 nucleus-animate-options-sheet-fade motion-reduce:nucleus-animate-none ${isPressGuarded ? 'nucleus-pointer-events-none' : ''}`, onPointerDown: (event) => {
            event.preventDefault();
        } }));
};
//# sourceMappingURL=options_sheet_backdrop.component.js.map